import builder from '../builder';
import DownloadBottom from '../../streamline-icons/light/download-bottom.svg';

export default builder('IconDownloadBottomLight', DownloadBottom);
